import { CoreEntityDto } from '@/interfaces/core.interface'
import { useCoreEntityStore } from '@/pinia/coreEntity'
import { setViewToMapview, setViewToPlanview } from '@/utils/views'
import { computed } from 'vue'
import { useStore } from 'vuex'
import { zoomToEntities } from './useMapbox'
import { useSelectionStore } from '@/pinia/selectionNew'
import { useLoadedEntities } from '@/pinia/loadedEntities'
import { storeToRefs } from 'pinia'

export default function useNavigateTo() {
  const store = useStore()
  const selection = useSelectionStore()
  const { loadedEntities } = storeToRefs(useLoadedEntities())
  const isDroneviewShowing = computed<boolean>(() => store.getters.isDroneviewShowing)
  const isMapviewShowing = computed<boolean>(() => store.getters.isMapviewShowing)
  const isPlanviewShowing = computed<boolean>(() => store.getters.isPlanviewShowing)
  const { getCoreEntity } = useCoreEntityStore()

  const navigateTo = async (id: string) => {
    if (!id) return
    selection.set([id])
    const foundEntity = await getCoreEntity(id)
    switch (foundEntity.type) {
      case 'COMPLEX':
        onClicked(foundEntity)
        break
      case 'REAL_ESTATE':
        onClicked(foundEntity)
        break
      case 'CONSTRUCTION':
        onClicked(foundEntity)
        break
      case 'LEVEL':
        onClicked(foundEntity)
        break
      case 'SPACE':
        onClicked(foundEntity)
        break
      default:
    }
  }
  async function handleClickBuilding(coreEntity: CoreEntityDto) {
    const building = loadedEntities.value.find((x) => x.properties.id === coreEntity.id)
    if (!building) return
    await store.dispatch('CHANGE_BUILDING', { building })
    zoomToEntities([building.id])
  }
  async function handleClickComplex(coreEntity: CoreEntityDto) {
    const complex = loadedEntities.value.find((x) => x.properties.belongsToId === coreEntity.id)
    if (!complex) return
    await store.dispatch('CHANGE_COMPLEX', { complex: complex.properties })
    zoomToEntities([complex.id])
  }
  async function handleClickLevel(coreEntity: CoreEntityDto) {
    const level = loadedEntities.value.find((x) => x.id === coreEntity.id)
    if (!level) return
    await store.dispatch('CHANGE_LEVEL', { levelNumber: level.properties.level })
    zoomToEntities([level.id])
  }
  async function handleClickRealEstate(coreEntity: CoreEntityDto) {
    const realEstate = loadedEntities.value.find((x) => x.id === coreEntity.id)
    if (!realEstate) return
    await store.dispatch('CHANGE_REAL_ESTATE', { realEstate: realEstate.properties })
    zoomToEntities([realEstate.id])
  }
  async function handleClickRoom(coreEntity: CoreEntityDto) {
    const room = loadedEntities.value.find((x) => x.id === coreEntity.id)
    if (!room) return
    await store.dispatch('CHANGE_ROOM', { roomId: room.id })
    zoomToEntities([room.id])
  }
  async function onClicked(coreEntity: CoreEntityDto) {
    if (coreEntity.type === 'COMPLEX') {
      store.commit('SET_CLICKED_ITEM_TYPE', { type: 'complex' })
      if (!isMapviewShowing.value) {
        setViewToMapview()
      }
      await handleClickComplex(coreEntity)
    }
    if (coreEntity.type === 'REAL_ESTATE') {
      store.commit('SET_CLICKED_ITEM_TYPE', { type: 'realEstate' })
      if (!isMapviewShowing.value) {
        setViewToMapview()
      }
      await handleClickRealEstate(coreEntity)
    }
    if (coreEntity.type === 'CONSTRUCTION') {
      store.commit('SET_CLICKED_ITEM_TYPE', { type: 'building' })
      if (!isMapviewShowing.value) {
        setViewToMapview()
      }
      await handleClickBuilding(coreEntity)
    }
    if (coreEntity.type === 'LEVEL') {
      store.commit('SET_CLICKED_ITEM_TYPE', { type: 'level' })
      // always set to planview when clicking on level??
      if (!isDroneviewShowing.value && !isPlanviewShowing.value) {
        setViewToPlanview()
      }
      await handleClickLevel(coreEntity)
    }
    if (coreEntity.type === 'SPACE') {
      store.commit('SET_CLICKED_ITEM_TYPE', { type: 'room' })
      // always set to planview when clicking on room??
      if (!isDroneviewShowing.value && !isPlanviewShowing.value) {
        setViewToPlanview()
      }
      if (!store.state.selectedLevel && coreEntity.parentId) {
        const level = await getCoreEntity(coreEntity.parentId)
        await handleClickLevel(level)
      }
      await handleClickRoom(coreEntity)
    }
  }
  return { navigateTo }
}
